import { NotificationEntityInDTO, NotificationEntityInfoOutDTO, TransportationTypeEnum, UserInfoOutDTO } from '@api/ringil-api.v2';

export const isEntityOwner = (loggedUser: UserInfoOutDTO, customerId: string) => loggedUser != null && customerId != null && loggedUser.companyId == customerId;

type DocNumbers = { transportationType?: TransportationTypeEnum; cmrNumber?: string; blNumber?: string; awbNumber?: string };

// The document number lives in the typed field for the current transport; mirror it to the deprecated shipmentId on save.
export const activeDocNumber = (v: DocNumbers): string | undefined => {
  switch (v.transportationType) {
    case TransportationTypeEnum.GROUND:
      return v.cmrNumber;
    case TransportationTypeEnum.TRAIN:
    case TransportationTypeEnum.BOAT:
      return v.blNumber;
    case TransportationTypeEnum.AIR:
      return v.awbNumber;
    default:
      return undefined;
  }
};

// Reverse of activeDocNumber: spread a legacy combined shipmentId into the typed doc field for the given transport.
// Used when seeding the form (e.g. duplication) from a source that may only carry the legacy number.
export const docNumbersFromShipmentId = (transportationType: TransportationTypeEnum, shipmentId?: string) => ({
  cmrNumber: transportationType === TransportationTypeEnum.GROUND ? shipmentId : undefined,
  blNumber: transportationType === TransportationTypeEnum.TRAIN || transportationType === TransportationTypeEnum.BOAT ? shipmentId : undefined,
  awbNumber: transportationType === TransportationTypeEnum.AIR ? shipmentId : undefined,
});

export const toUIMapNotifyData = (notifyData: NotificationEntityInfoOutDTO): NotificationEntityInDTO => {
  return {
    notifyUsersDependsOnRole: notifyData.notifyUsersDependsOnRole,
    userIdsToNotify: notifyData.usersToNotify ? notifyData.usersToNotify.map(t => t.id) : [],
    responsiblePersonId: notifyData.responsiblePerson?.id,
  };
};

export const toBoolean = (value: any) => {
  if (value === true) return true;
  if (value === false) return false;
  if (value === 'true') return true;
  if (value === 'false') return false;
  return false;
};
